'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/styles');

var _Tabs = require('@material-ui/core/Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = require('@material-ui/core/Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _Typography = require('../Typography');

var _tabs = require('../../schema/component/tabs.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      background: 'var(--onprimary-high-emphasis)',
      boxShadow: function boxShadow(_ref) {
        var tabsBoxShadow = _ref.tabsBoxShadow;
        return tabsBoxShadow;
      },
      width: function width(_ref2) {
        var tabsWidth = _ref2.tabsWidth;
        return tabsWidth;
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'var(--primary-500)'
      },
      '& .MuiTab-root': {
        minWidth: function minWidth(_ref3) {
          var tabWidth = _ref3.tabWidth;
          return tabWidth;
        }
      },
      '& .MuiTabs-flexContainer': {
        borderBottom: function borderBottom(_ref4) {
          var isScroll = _ref4.isScroll;
          return !isScroll && '1px solid var(--outline-soft)';
        },
        height: function height(_ref5) {
          var tabsHeight = _ref5.tabsHeight;
          return tabsHeight || '48px';
        }
      },
      '& .MuiTabs-scroller.MuiTabs-scrollable': {
        borderBottom: function borderBottom(_ref6) {
          var isScroll = _ref6.isScroll;
          return isScroll && '1px solid var(--outline-soft)';
        }
      },
      '& .MuiTabScrollButton-root': {
        width: '52px'
      },
      '& .MuiTabs-scrollButtons': {
        color: 'var(--onsurface-inactive)'
      },
      '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        marginBottom: '8px'
      }
    },
    tabItem: {
      '&[aria-selected="true"], &[aria-selected="true"] *': {
        color: 'var(--primary-900)'
      },
      '&[aria-selected="true"] svg, &[aria-selected="true"] svg > path': {
        color: 'var(--primary-700)'
      },
      '&[aria-selected="false"], &[aria-selected="false"] *': {
        color: 'var(--onsurface-inactive)'
      }
    },
    tabItemLabel: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      textTransform: 'capitalize'
    }
  };
});

var Tabs = function Tabs(_ref7) {
  var className = _ref7.className,
      height = _ref7.height,
      onChange = _ref7.onChange,
      options = _ref7.options,
      tabProps = _ref7.tabProps,
      value = _ref7.value,
      variant = _ref7.variant,
      width = _ref7.width,
      props = _objectWithoutProperties(_ref7, ['className', 'height', 'onChange', 'options', 'tabProps', 'value', 'variant', 'width']);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      tab = _useState2[0],
      setTab = _useState2[1];

  var schemaVariant = _tabs.properties[variant] && _tabs.properties[variant].properties;
  var schemaDefault = _tabs.properties['fixed-flat'] && _tabs.properties['fixed-flat'].properties;
  var schemaSelected = schemaVariant || schemaDefault;

  var onStyleTabWidth = function onStyleTabWidth() {
    if (variant.includes('scrollable')) return '120px';
    return 100 / (options && options.length || []) + '%';
  };

  var classes = useStyles({
    tabsBoxShadow: schemaSelected.boxShadow,
    tabsWidth: width,
    tabsHeight: height,
    tabWidth: onStyleTabWidth(),
    isScroll: schemaSelected.isBorderScroll
  });

  var onChangeSelf = function onChangeSelf(_event, payload) {
    setTab(payload);
    onChange(payload);
  };

  (0, _react.useEffect)(function () {
    return setTab(value);
  }, [value]);

  return _react2.default.createElement(
    _Tabs2.default,
    _extends({}, props, {
      className: 'tabs ' + classes.container + ' ' + className,
      value: tab,
      variant: schemaSelected.variant,
      onChange: onChangeSelf
    }),
    (options || []).map(function (_ref8) {
      var Icon = _ref8.Icon,
          label = _ref8.label;
      return _react2.default.createElement(_Tab2.default, _extends({}, tabProps, {
        key: label,
        className: classes.tabItem,
        icon: Icon && _react2.default.createElement(Icon, null),
        label: label && _react2.default.createElement(
          _Typography.Typography,
          { className: classes.tabItemLabel, variant: 'textbutton' },
          label
        )
      }));
    })
  );
};

exports.Tabs = Tabs;
Tabs.defaultProps = {
  className: null,
  height: '48px',
  onChange: function onChange() {},
  options: [{ label: 'Tab' }, { label: 'Tab' }, { label: 'Tab' }],
  tabProps: null,
  value: 0,
  variant: 'fixed-flat',
  width: '100%'
};

Tabs.propTypes = {
  className: _propTypes2.default.string,
  height: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    Icon: _propTypes2.default.node
  })),
  tabProps: _propTypes2.default.shape({}),
  value: _propTypes2.default.number,
  variant: _propTypes2.default.string,
  width: _propTypes2.default.string
};

exports.default = Tabs;